// useNodes({ refetchMs = 5000, enabled }) → UseQueryResult<Node[]>     key ["nodes"]
// Execution nodes and their slots; the nav fleet readout and Submit capacity line poll it every 5 s.
// The cache holds the raw GET /v1/nodes body ({ nodes }) and `select` unwraps it, so every reader of
// ["nodes"] (including code that calls api.nodes() directly) shares one cached shape.
// GET /v1/nodes already lists only nodes whose heartbeat is fresher than the controller's
// NodeStaleAfter (15 s by default), judged on the controller's clock.
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Node } from "@/types";
import { keys } from "./keys";

export const NODES_POLL_MS = 5000;

const selectNodes = (r: { nodes?: Node[] | null }): Node[] => r.nodes ?? [];

export function useNodes(opts: { refetchMs?: number | false; enabled?: boolean } = {}) {
  return useQuery({
    queryKey: keys.nodes,
    queryFn: () => api.nodes(),
    select: selectNodes,
    refetchInterval: opts.refetchMs ?? NODES_POLL_MS,
    enabled: opts.enabled ?? true,
  });
}

